/** Twin Details' own content column (`OnboardingTwinDetails`), so the step's other blocks line up with it. */
export const TWIN_DETAILS_COLUMN = '720px';
